import { Box, Text } from '@mantine/core';
import { barve } from '../tema';

/**
 * »AvtoPisarna.« z rumeno piko (kot je bila pri »HERA.« – TemaElementi.logotip v Swingu); {@code temno} = temno
 * besedilo na svetli podlagi.
 */
export function Logotip({
  velikost = 48,
  podnaslov,
  temno = false,
}: {
  velikost?: number;
  podnaslov?: string;
  temno?: boolean;
}) {
  return (
    <Box ta={temno ? 'left' : 'center'}>
      <Text
        component="div"
        fw={700}
        c={temno ? barve.besedilo : 'white'}
        lh={1}
        style={{ fontSize: velikost, letterSpacing: -1 }}
      >
        AvtoPisarna<span style={{ color: barve.poudarek }}>.</span>
      </Text>
      {podnaslov && (
        <Text size="sm" mt={8} style={{ color: barve.besediloNaOzadjuSekundarno }}>
          {podnaslov}
        </Text>
      )}
    </Box>
  );
}
